<section>
  <details
    #detailsElement
    class="ds-details ds-relative ds-text-xl sm:ds-w-5xl ds-min-h-[51px]"
    role="listbox"
    [class.!ds-w-full]="fluid"
    [attr.open]="open || null"
    [attr.disabled]="isDisabled || null"
    [attr.aria-disabled]="isDisabled"
    [attr.aria-invalid]="isInvalid"
    [attr.aria-describedby]="'alert-' + id"
    [attr.aria-multiselectable]="multiple"
    [attr.aria-required]="required"
    (click)="onToggle($event)"
    (keydown.space)="onToggle($event)"
    (keydown.enter)="$event.preventDefault()"
  >
    <summary
      class="
        ds-px-lg
        ds-py-[10px]
        ds-border
        ds-min-w
        ds-rounded-md
        ds-border-tertiary-lightgrey
        ds-cursor-pointer
      "
      tabindex="0"
      (blur)="onBlur()"
      [class.hover:ds-border-tertiary-mediumgrey]="inputOptionDirectives.length"
      [class.ds-border-tertiary-lightergrey]="isDisabled"
      [ngClass]="{
        'ds-text-tertiary-mediumgrey !ds-border-primary-blue ds-rounded-b-none ds-border-b-0':
          open,
        '!ds-border-secondary-red': open && validate && isTouched && isInvalid,
        'ds-border-secondary-red-70 hover:ds-border-secondary-red focus-within:ds-border-secondary-red hover:focus-within:ds-border-secondary-red':
          validate && isTouched && isInvalid,
        'ds-border-secondary-green-70 hover:ds-border-secondary-green focus-within:ds-border-secondary-green hover:focus-within:ds-border-secondary-green':
          validate && isTouched && isValid,
        '!ds-border-secondary-green': open && validate && isTouched && isValid
      }"
    >
      <div
        class="ds-font-regular"
        [class.ds-truncate]="truncate"
        [title]="getSelectedTitle()"
      >
        <ng-container *ngIf="selectedLabels.length; else defaultLabel">
          <ng-container
            *ngFor="let selectedLabel of selectedLabels; let last = last"
          >
            <span>
              {{ selectedLabel.label }}
              <small
                *ngIf="!multiple && selectedLabel.sublabel"
                class="ds-block"
              >
                {{ selectedLabel.sublabel }}
              </small>
            </span>
            <span>{{ last ? "" : ", " }}</span>
          </ng-container>
        </ng-container>
      </div>
    </summary>
    <div
      *ngIf="inputOptionDirectives.length"
      class="
        ds-border
        ds-bg-primary-white
        ds-z-50
        ds-rounded-md
        ds-rounded-t-none
        ds-border-t-0
        ds-overflow-scroll
        ds-scrollbar-hide
        ds-left-0
        ds-right-0
        ds-absolute
      "
      [class.ds-border-primary-blue]="open"
      [class.ds-border-secondary-red]="
        open && validate && isTouched && isInvalid
      "
      [class.ds-border-secondary-green]="
        open && validate && isTouched && isValid
      "
      [class.ds-relative]="relative"
      [style.max-height]="maxHeight"
    >
      <label
        #labelElement
        *ngFor="
          let inputOptionDirective of inputOptionDirectives;
          let first = first
        "
        role="option"
        [title]="inputOptionDirective.label"
        [attr.aria-checked]="inputOptionDirective.selected"
        class="
          ds-px-lg ds-py-[10px] ds-cursor-pointer ds-text-primary-black
          hover:ds-bg-primary-blue hover:ds-text-primary-white
          focus-within:ds-bg-primary-blue/20 focus-within:ds-outline-none
          ds-flex
        "
        (click)="onSelected($event, inputOptionElement)"
      >
        <input
          #inputOptionElement
          class="ds-appearance-none"
          [name]="id"
          [tabindex]="first ? 0 : -1"
          [type]="multiple ? 'checkbox' : 'radio'"
          [value]="inputOptionDirective.value"
          [checked]="inputOptionDirective.selected"
          (keydown)="onNavigate($event)"
        />
        <span class="ds-flex-grow" [class.ds-truncate]="truncate">
          {{ inputOptionDirective.label }}
          <small *ngIf="inputOptionDirective.sublabel" class="ds-block">
            {{ inputOptionDirective.sublabel }}
          </small>
        </span>
        <span
          *ngIf="inputOptionDirective.selected"
          class="
            ds-icon ds-icon-checkmark ds-pl-xs ds-w-xl ds-relative
            before:!ds-text-lg
          "
        ></span>
      </label>
    </div>
  </details>
  <div
    class="ds-text-xs ds-mt-2xs"
    [id]="'alert-' + id"
    [style.display]="error || hint ? 'block' : 'none'"
  >
    <span role="alert" class="ds-text-secondary-red ds-opacity-80">
      {{ error }}
    </span>
    <span class="ds-text-tertiary-mediumgrey">
      {{ hint }}
    </span>
  </div>
</section>

<ng-template #defaultLabel>
  <ng-template [ngIf]="label">{{ label }}</ng-template>
  <ng-template [ngIf]="!label">
    <ng-content select="*:not(ui-input-option)"></ng-content>
  </ng-template>
  <small *ngIf="sublabel" class="ds-block">
    {{ sublabel }}
  </small>
</ng-template>

<!--
  TODO (stefan):
  Check what happends if inside a reactive form.
  When the native control updates it should update the 
  styled dropdown as well
-->
<select
  #inputElement
  class="ds-hidden"
  aria-hidden="true"
  [multiple]="multiple"
  [required]="required"
>
  <!--
    Adding a blank option to have an indetermented state, similarly to
    the visible list selector.
  -->
  <option hidden selected></option>
  <option
    *ngFor="let inputOptionDirective of inputOptionDirectives"
    [value]="inputOptionDirective.value"
    [selected]="inputOptionDirective.selected"
  >
    {{ inputOptionDirective.elementRef.nativeElement.textContent }}
  </option>
</select>
